import { Box, Divider, Stack } from "@mui/material";
import { IconHourglass } from "src/components/icons-mui/hourglass";
import { ArrowLink } from "src/components-mui/base/arrow-link/arrow-link";
import { Button } from "src/components-mui/base/button/button";
import { SimpleRichText } from "src/components-mui/common/rich-text/simple-rich-text";
import { CBDetailsAccordion } from "src/components-mui/pages/detail/certificate-box/components/details-accordion";
import { CBFooter } from "src/components-mui/pages/detail/certificate-box/components/footer";
import { CBHeader } from "src/components-mui/pages/detail/certificate-box/components/header/header";
import { InfoBox } from "src/components-mui/pages/detail/certificate-box/components/info-box";
import { CBInvestedCapital } from "src/components-mui/pages/detail/certificate-box/components/invested-capital";
import { CBPrices } from "src/components-mui/pages/detail/certificate-box/components/prices";
import { CBRatioTabBar } from "src/components-mui/pages/detail/certificate-box/components/ratio-tab-bar";
import { SpacedContainer } from "src/components-mui/pages/detail/certificate-box/components/spaced-container";
import {
    CBCertificateFee,
    CBEmission,
    CBExchangeRatio,
    CBLiquidationFigure,
    CBPerformanceFee,
    CBTradingVolume,
} from "src/components-mui/pages/detail/certificate-box/components/statistics";
import { useCertificateBoxContext } from "src/components-mui/pages/detail/certificate-box/context";

const CLOSING_MESSAGE_TEST_ID = "closing-message";
const CLOSING_BUTTON_TEST_ID = "closing-button";

export const CertificateBoxClosingInProgress = () => {
    const { dict, data, selectedCertificate: certificate } = useCertificateBoxContext();
    const isHiddenCertificate = certificate.isHidden;

    return (
        <>
            <CBHeader />
            <SpacedContainer>
                {data.certificates.length > 1 && <CBRatioTabBar />}
                <CBPrices />
                <Divider />

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <CBCertificateFee />
                    <CBPerformanceFee />
                    <CBInvestedCapital />
                </Box>

                <Divider />

                <CBDetailsAccordion>
                    <Stack spacing={1}>
                        <CBEmission />
                        <CBLiquidationFigure />
                        <CBTradingVolume />
                        {isHiddenCertificate && <CBExchangeRatio />}
                    </Stack>
                    <Divider sx={{ pt: 2 }} />
                </CBDetailsAccordion>

                <InfoBox icon={<IconHourglass sx={{ mt: 0.2, width: "18px", height: "18px" }} />}>
                    <Stack spacing={1}>
                        <SimpleRichText text={dict.closingMessage} fontSize="sm" data-test-id={CLOSING_MESSAGE_TEST_ID} />

                        {certificate.closingLinkUrl ? (
                            <ArrowLink sx={{ alignSelf: "flex-start" }} href={certificate.closingLinkUrl}>
                                {dict.closingLink}
                            </ArrowLink>
                        ) : null}
                    </Stack>
                </InfoBox>
                <Button
                    component="a"
                    target="_blank"
                    href={certificate.closingClosedButtonUrl}
                    color="green"
                    size="medium"
                    data-test-id={CLOSING_BUTTON_TEST_ID}
                >
                    {dict.closingClosedButton}
                </Button>

                <CBFooter />
            </SpacedContainer>
        </>
    );
};
